module.exports = __webpack_public_path__ + "catalog/items/firesafety/fire-exit-left/fire-exit-left.svg";